function ShippingCostTracker(analytics) {
	'use strict';

	this.analytics = analytics;

	this.inputLocations = {
 		'header'  : 'Header',
 		'product' : 'Product',
 		'cart'    : 'Cart'
	};

	this.$headerShippingInput  = $('.header .shipping-selector__input');
	this.$cartShippingInput    = $('.cart .shipping-calculator__submit');
	this.$productShippingInput = $('.product .shipping-calculator__submit');

}

ShippingCostTracker	.prototype = {
	init: function () {
		'use strict';

		this.initShippingInputLocation();
	},

  	/**
     * @param {String} container
     * @param {Array} config
     */
    initShippingInputLocation: function() {
        'use strict';

        if (this.$headerShippingInput.length) {
        	this.$headerShippingInput.on(
        		'change',
        		$.proxy(
        			this.trackShippingInputLocation,
        			this,
        			this.inputLocations.header
    			)
    		);
        }

        if (this.$cartShippingInput.length) {
        	this.$cartShippingInput.on(
        		'click',
        		$.proxy(
        			this.trackShippingInputLocation,
        			this,
        			this.inputLocations.cart
    			)
    		);
        }

        if (this.$productShippingInput.length) {
        	this.$productShippingInput.on(
        		'click',
        		$.proxy(
        			this.trackShippingInputLocation,
        			this,
        			this.inputLocations.product
    			)
    		);
        }
    },
    trackShippingInputLocation: function (location) {
    	'use strict';
    	this.analytics.track('Shipping', 'Location Input', location, 1);
    }
};

export default ShippingCostTracker;